import { Expose, Type } from "class-transformer";

export class CountyCoverage {
  @Expose()
  accountManagerId: string;

  @Expose()
  accountManagerEmail: string;

  @Expose()
  accountManagerName: string | null;

  @Expose()
  accountManagerIsActive: boolean;

  @Expose()
  validFrom: Date;
}

export class County {
  @Expose()
  fips: string;

  @Expose()
  name: string;

  @Expose()
  stateCode: string;

  @Expose()
  stateName: string;

  @Expose()
  @Type(() => CountyCoverage)
  coverage: CountyCoverage | null;
}
